import { SelectChangeEvent } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import BorderHeading from '../../components/heading/BorderHeading'
import "./OrderConfiguration.css"
import { DashboardCheckbox, DashboardSelect } from '../../components/Input/Input';
import Input from "../../components/Input/Input"
import store from '../../stateManagement/store';
import { configurationAttributeType, orderConfigurationValuesTypes} from '../../types';
import * as yup from 'yup';
import ConfigurationHeader from '../../components/heading/ConfigurationHeader';
import { convertValuesToConfig, createValidation, doFinalConfigSubmit, getMetaData, getMetaDataConfig, getNewConfiguration, overWriteConfig, postConfiguration, updateConfiguration } from '../../services/uiConfigService';
import { defaultInputValues } from '../../components/constants/uiConfigConstants';
import * as Sentry from "@sentry/react";
import QuestionHeading from '../../components/heading/QuestionHeading';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { IndentWrapper } from './OrderConfiguration';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes';
import ConfigComparePopup from '../../components/popup/ConfigComparePopup';
import ImportConfig from '../../components/importConfig/ImportConfig';



const CartConfiguration = () => {
    const [orderConfig, setOrderConfig] = useState<configurationAttributeType[]>([]);
    const [values, setValues] = useState<orderConfigurationValuesTypes>(deepClone(defaultInputValues))
    const [basketTitles,setBasketTitles]=useState<string[]>([]);
    const [orderValidationsSchema, setOrderValidationSchema] = useState({})

    const [showConfigPopup,setShowConfigPopup] = useState<boolean>(false);
    const curConfigRef = useRef<{[key:string]:any[]}>({});
    const newConfigRef = useRef<{[key:string]:any[]}>({});


    const getOrderConfiguration = async () => {
        try {
            const resp = await getNewConfiguration('order_configuration');
            const basketConfigResp = await getNewConfiguration('order_basket_configuration');
            const order_config: configurationAttributeType[] = resp?.domainValues;
            curConfigRef.current.order_configuration = order_config  ?? [];
            const result: { id: string, color: string, label: string, value: boolean }[] = [];
            const basketList:string[]=[];
            basketConfigResp && basketConfigResp["domainValues"][0]['value'].forEach((basket:{[key:string]:string})=>{
                basketList.push(basket['id']);
            })
            setBasketTitles([...basketList]);
            
            setOrderConfig([...order_config])
        } catch (err) {
            // Sentry.captureException(err);
        }
    }
    useEffect(() => {

        getOrderConfiguration();
    }, [])
    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.checked, isValueUpdated:true} 
        })
    }
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }


    const handleSelectValueChange = (e: SelectChangeEvent<unknown>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        });
    }

    const setOrderConfigValues = () => {
        try {
            if (orderConfig.length) {
                const result = { ...values };
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                orderConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr;
                })
                setValues({ ...result } as orderConfigurationValuesTypes);
                setOrderValidationSchema({ ...resValidations })
            }
        } catch (err) {
            // Sentry.captureException(err);
        }
    }

    const saveConfiguration = async (preview?: boolean) => {
            try {
                const resultantValues:orderConfigurationValuesTypes = { ...values};
                const orderSchema = yup.object({ ...orderValidationsSchema })
                const validationObject:any = {};
                Object.keys(resultantValues).forEach(key=>{
                    validationObject[key] = resultantValues[key].value;
                })
                // await orderSchema.validate(validationObject)
                const convertedVals = convertValuesToConfig(resultantValues, orderConfig);
                newConfigRef.current.order_configuration = convertedVals;
                setShowConfigPopup(true);

            } catch (err) {
                // Sentry.captureException(err);
                console.log("err===", err)
                if (err instanceof Error)
                    openPopup( 'Error',"Validation Error occured : " + err?.message)
            }
    }

    const importConfiguration = async (importedConfig:any)=>{
        const newConfigs = await overWriteConfig(importedConfig, {
            // order_configuration:["minOrderValidation","minOrderVisibility","minOrderType","minOrder","buyInSets","showMissedSchemePopUp","missedPoPUpMargin","estimatedDeliveryDateVisibility","orderFulfillmentTime","orderFulfillmentTimeMessage","fullFilledByLabel","missedItemBasket"]
            order_configuration: "importAll"
        })
        newConfigs.forEach((item) => {
            newConfigRef.current[item.domainType] = item.domainValues;
        });
        setShowConfigPopup(true);
        // for(const configObject of newConfigs){
        //     await doFinalConfigSubmit(configObject.domainType, configObject.domainValues)
        // }
        // getOrderConfiguration()
    }

    const  onConfigComparatorSuccess=async () => {
        await doFinalConfigSubmit("order_configuration",newConfigRef.current.order_configuration,curConfigRef)
        getOrderConfiguration();
      }

    const [importConfigState,setImportConfigState] = useState(false);


    useEffect(() => {
        setOrderConfigValues();
    }, [orderConfig])
    return (
        <div className="order_config_container">
            <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={['order_configuration']} importConfigCallback={importConfiguration} />
            <ConfigurationHeader heading={"Cart Configuration"} importConfiguration={()=>{setImportConfigState(true)}} saveConfiguration={() => saveConfiguration(false)}  />
            <div className="config_form_container">

                

                <div className="form_header">
                    <BorderHeading>CART PAGE </BorderHeading>
                </div>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Do you want to have minimum condition for placing order
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.minOrderValidation.value} name="minOrderValidation" label="Yes" />
                    </div>
                </IndentWrapper>

                    <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Should the minimum order be visible?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.minOrderVisibility.value} name="minOrderVisibility" label="Yes" />
                    </div>
                </IndentWrapper>


                    <IndentWrapper indent={1}>
                        <QuestionHeading>
                            Min Order condition should be?
                        </QuestionHeading>
                        <div className="answer_container">
                            <DashboardSelect onChange={handleSelectValueChange} value={values.minOrderType.value} name="minOrderType" options={values.minOrderType.possibleVals ?? []} selectLableId='Select min order type' />
                        </div>
                    </IndentWrapper>

                    <IndentWrapper indent={2}>
                        <QuestionHeading>
                            Enter the min order value
                        </QuestionHeading>
                        <div className="answer_container">
                            <Input type='number' onChange={handleValueChange} value={values.minOrder.value} name="minOrder" />
                        </div>
                    </IndentWrapper>


                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    Do you wish that the user be able to place orders in sets?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.buyInSets.value} name="buyInSets" label="Yes" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    When the scheme is missed, do you want the user to be able to see a disclaimer that the scheme has been missed?
                    </QuestionHeading>
                    <div className="answer_container">
                    <DashboardCheckbox onChange={handleCheckChange} checked={values.showMissedSchemePopUp.value} name="showMissedSchemePopUp" label="Yes" />
                    </div>
                </IndentWrapper>

                    {values.showMissedSchemePopUp &&
                    

                <IndentWrapper indent={2}>
                        <QuestionHeading>
                        After how much percentage of order
                        </QuestionHeading>
                        <div className="answer_container">
                            <Input value={values.missedPoPUpMargin.value} onChange={handleValueChange} name="missedPoPUpMargin" />
                        </div>
                    </IndentWrapper>
                }

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Do you want the information regarding delivery date to be visible?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.estimatedDeliveryDateVisibility.value} name="estimatedDeliveryDateVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                
                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Enter the number of days for delivery in order fulfillment time
                    </QuestionHeading>
                    <div className='answer_container'>
                        <Input type="number" value={values.orderFulfillmentTime.value} onChange={handleValueChange} name="orderFulfillmentTime" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        what should be the text in place of order fullfillment time?
                    </QuestionHeading>
                    <div className='answer_container'>
                        <Input value={values.orderFulfillmentTimeMessage.value} onChange={handleValueChange} name="orderFulfillmentTimeMessage" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        What should be the label for Fulfilled by?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.fullFilledByLabel.value} onChange={handleValueChange} name="fullFilledByLabel" />
                    </div>
                </IndentWrapper>

               
                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    In the basket titled: “items you may have missed”, which basket should be displayed?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleSelectValueChange} value={values.missedItemBasket.value} name="missedItemBasket" options={basketTitles} selectLableId='missed basket' />
                    </div>
                </IndentWrapper>


            </div>
            <ConfigComparePopup message="Are you sure want to update the config" showConfigPopup={showConfigPopup} setShowConfigPopup={setShowConfigPopup} curConfig={curConfigRef.current} newConfig={newConfigRef.current} onSuccess={onConfigComparatorSuccess } />
        </div>
    )
}

export default CartConfiguration

